import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const FaqBreadcrumb = () => {
   return (
      <>
         <Breadcrumb title="Asked" subTitle="Question" smText='Faq'></Breadcrumb>
      </>
   );
};

export default FaqBreadcrumb;